import styled from "@emotion/styled";

export const PhoneInputContainer = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: 116px 1fr;
`;

export const InputWrapper = styled.div`
  position: relative;
`;
